import * as React from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

import ERouteAccountant from "@/accountant/ERouteAccountant"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"

export function SiteHeader() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const title = pathname.endsWith("/invoices")
    ? t("Accountant::Invoices")
    : pathname.endsWith("/expenses")
      ? t("Accountant::Expenses")
      : pathname.endsWith("/integrations")
        ? t("Accountant::Integrations")
      : pathname.startsWith(ERouteAccountant.PATH_CLIENTS)
        ? t("Accountant::Clients")
        : pathname.startsWith(ERouteAccountant.PATH_ACCOUNT)
          ? t("Accountant::Account")
          : t("Accountant::Accounting")

  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 h-4 data-vertical:self-auto"
        />
        <h1 className="text-base font-medium">{title}</h1>
      </div>
    </header>
  )
}
